import React, { useEffect, useRef } from 'react';

const GoogleAd = ({ slot, format = 'auto', style = {}, responsive = 'true' }) => {
  const adRef = useRef(null);
  const isAdInitialized = useRef(false);

  useEffect(() => {
    let timeoutId;
    let retryTimeoutId;

    const initializeAd = () => {
      try {
        // Ensure AdSense script is loaded
        if (!window.adsbygoogle) {
          const script = document.createElement('script');
          script.src = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-6474718869353915';
          script.async = true;
          script.crossOrigin = 'anonymous';
          document.head.appendChild(script);
        }

        // Wait for the script to load and the DOM to be ready
        timeoutId = setTimeout(() => {
          if (!isAdInitialized.current && adRef.current) {
            // Check if the ad container has proper dimensions
            const rect = adRef.current.getBoundingClientRect();
            
            if (rect.width > 0 && rect.height > 0) {
              try {
                (window.adsbygoogle = window.adsbygoogle || []).push({});
                isAdInitialized.current = true;
              } catch (err) {
                console.error('Error pushing ad:', err);
              }
            } else {
              // Retry after a longer delay if dimensions are not ready
              retryTimeoutId = setTimeout(() => {
                if (!isAdInitialized.current && adRef.current) {
                  const retryRect = adRef.current.getBoundingClientRect();
                  try {
                    (window.adsbygoogle = window.adsbygoogle || []).push({});
                    isAdInitialized.current = true;
                  } catch (err) {
                    console.error('Error pushing ad (retry):', err);
                  }
                }
              }, 1000);
            }
          }
        }, 500);
      } catch (err) {
        console.error('Error loading AdSense:', err);
      }
    };

    initializeAd();

    // Cleanup function
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      if (retryTimeoutId) {
        clearTimeout(retryTimeoutId);
      }
      isAdInitialized.current = false;
    };
  }, []);

  return (
    <ins
      ref={adRef}
      className="adsbygoogle"
      style={style}
      data-ad-client="ca-pub-6474718869353915" // Replace with your AdSense client ID
      data-ad-slot={slot}
      data-ad-format={format}
      data-full-width-responsive={responsive}
    />
  );
};

export default GoogleAd; 